import { render, staticRenderFns } from "./FirmaDigital.vue?vue&type=template&id=2d336ddd"
import script from "./FirmaDigital.vue?vue&type=script&lang=js"
export * from "./FirmaDigital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports